
const token = localStorage.getItem("auth_token");
const admin = localStorage.getItem("admin")
const vm = localStorage.getItem("vm")
const smartmach = localStorage.getItem("smartmach")
const maintainer = localStorage.getItem("maintainer")
const company = localStorage.getItem("company")
const parent_company = localStorage.getItem("parent_company")

export default {
  token,
  authenticated: !!token,
  admin,
  vm,
  smartmach,
  maintainer,
  company,
  parent_company
}